import Vue from "vue";
import { postApi } from "@/utils/http";
import { _order, getReversed } from "@/utils/order";

export default {
  namespaced: true,
  state: { domains: [] },
  mutations: {
    edit(state, { d, obj }) {
      const index = state.domains.findIndex((x) => x.uid === d.uid);
      if (index !== -1) {
        const item = state.domains[index];
        Vue.set(state.domains, index, { ...item, ...obj });
      }
    },
    add(state, domain) {
      state.domains.unshift(domain);
    },
    remove(state, d) {
      const index = state.domains.findIndex((x) => x.uid === d.uid);
      if (index !== -1) Vue.delete(state.domains, index);
    },
    set(state, domains) {
      state.domains = domains;
    },
    clear(state) {
      state.domains = [];
    },
  },
  actions: {
    async fetch({ dispatch, rootState, commit, state }, force) {
      if (state.domains.length === 0 || force) {        
        const domains = await postApi("get/domains");

        if (domains) {
          await dispatch(
            "settings/getUserSetting",
            { path: "domains", key: "order" },
            { root: true }
          );          

          commit(
            "set",
            _order(domains, rootState.settings.user.domains?.order)
          );
        }
      }
    },
    async add({ commit, state }, name) {
      const res = await postApi("create/domain", {
        friendlyName: name,
        domainDescription: "",
      });

      commit("add", res[0]);
    },
    async delete({ commit, state }, domain) {
      const res = await postApi("delete/domain", {
        uid: domain.uid,
      });

      commit("remove", domain);
    },
    async order({ dispatch, commit, state, rootState }, order) {
      const stateOrder = rootState.settings.user.domains?.order;
      order = getReversed(stateOrder, order);

      dispatch(
        "settings/setUser",
        { path: "domains", key: "order", value: order },
        { root: true }
      );

      commit("set", _order(state.domains, order));
    },
  },
  getters: {
    single: (state) => (domainUID) => {
      return state.domains.find((x) => x.uid === domainUID);
    },
  },
  modules: {},
};
